import { ProductCardAnimationContext } from 'product-card/context/ProductCardAnimationContext'
import { useContext } from 'react'

export const useProductCardAnimationContext = () => {
	return useContext(ProductCardAnimationContext)
}
